import CaseMedicationsContainer from './CaseMedicationsContainer';

export default CaseMedicationsContainer;
